import { createFileRoute } from "@tanstack/react-router";
import { RelatorioPagamentoProdutor } from "pages/relatorios/pages/pagamento_produtor";

export const Route = createFileRoute("/a/relatorios/pagamento-produtor")({
	component: RelatorioPagamentoProdutor,
});
